<div class="card">
    <!-- Header -->
    <div class="header">
      <div class="icon">
        <img [src]="avatar" alt="icon" />
      </div>
      <div class="title">
        <h2>{{ name }}</h2>
        <div class="info">
          <span>Oferecida por <strong>{{ sponsor }}</strong></span>
          <span>•</span>
          <span>{{ vacancies }} vagas</span>
          <span>•</span>
          <span><span class="status">{{ estado }}</span></span>
        </div>
      </div>
      <div class="indicators">
        <div class="avatars">
          <p-avatar-group>
            <p-avatar icon="pi pi-user" shape="circle" size="normal" />
            <p-avatar icon="pi pi-user" shape="circle" size="normal" />
            <p-avatar icon="pi pi-user" shape="circle" size="normal" />
            <p-avatar [label]="'+' + extraParticipants" shape="circle" size="normal" [style]="{ 'background-color': '#ebebef', color: '#333', 'font-size': '0.75rem' }" />
          </p-avatar-group>
          <span class="counter-desc">Estudantes</span>
        </div>
      </div>
    </div>

    <!-- Description -->
    <p class="description">
      {{ description }}
    </p>

    <!-- Date and Tags -->
    <div class="contact-info">
      <div class="phone">
        <div class="icon">
          <img src="icons/phone.svg" alt="Phone Icon" />
        </div>
        <span>{{ startDate }} à {{ endDate }}</span>
      </div>
      <div class="email">
        <div class="icon">
          <img src="icons/award-01.svg" alt="Email Icon" />
        </div>
        <span>{{ tipoBolsa }}</span>
      </div>
      <div class="email">
        <div class="icon">
          <img src="icons/graduation-grey.svg" alt="Email Icon" />
        </div>
        <span>{{ duration }}</span>
      </div>
      <div class="email">
        <div class="icon">
          <img src="icons/coins-hand.svg" alt="Email Icon" />
        </div>
        <span>{{ estado }}</span>
      </div>
      <div class="country">
        <div class="icon">
          <img src="icons/globe.svg" alt="Country Icon" />
        </div>
        <span>{{ country }}</span>
      </div>
    </div>
  </div>
